import React, { useState, useEffect } from "react";
import "./UserAccountTransfers.scss";
import LanguageIcon from "@mui/icons-material/Language";
import Select from "../../UI/Select/Select";
import Input from "../../UI/Input/Input";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { ValidateToken, claimTransfer, getCustomerAccount } from "../../../util/API/transfer";
import { useSelector } from "react-redux";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import PinPad from "../../PinPad/PinPad";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { countryList } from "../../../constants/countrylist";
import { getReceipts } from "../../../util/API/transfer";
import { getErrorMessage, getErrorMessage2 } from "../../../util/utilfunctions/utilFunctions";


function ClaimLocalTransfers() {
  const [txtoken, setTxToken] = useState("");
  const [claimcode, setClaimCode] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [senderName, setSenderName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [fee, setFee] = useState(0.0);
  const [total, setTotal] = useState(0.0);
  const [claimAccounts, setClaimAccounts] = useState([]);
  const [tokenData, setTokenData] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("error");
  const [message, setMessage] = useState("");
  const [header, setHeader] = useState("");
  const [showPinPad, setShowPinPad] = useState(false);
  const [receipt, setReceipt] = useState(false);
  const [receiptIDData, setReceiptIDData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  let isOperator = sessionStorage.getItem("isOperator");
  let configVariables = useSelector((state) => state.config.baseConfig);
  let isAutoRetry;

  let pin = sessionStorage.getItem("pin");
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const parentuserid = sessionStorage.getItem("parentuserid");

  // Dummy function to calculate fee, this should be replaced with actual logic
  const calculateFee = () => {
    // Set static fee for demonstration purposes
    const calculatedFee = 0.0;
    setFee(calculatedFee);
    setTotal(parseFloat(inputValue) + calculatedFee);
  };

  const user = useSelector((state) => state.usersList.userID);

  const getAccounts = async () => {
    const response = await getCustomerAccount(user['User'].id);
      const records = response.ServiceData.record.filter(
        (record) => record.Vtransfersourcepis.piid === "229"
      );

      // Filter out duplicates based on unique identifiers (e.g., account ID)
      const uniqueRecords = records.filter(
        (record, index, self) =>
          index === self.findIndex(
            (r) => r.Vtransfersourcepis.acctID === record.Vtransfersourcepis.acctID
          )
      );

      setClaimAccounts(uniqueRecords);
  };

  useEffect(() => {
    getAccounts();
  }, []);

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  // console.log(pinConfiguration)

  const options = claimAccounts.map((record) => ({
    key: record.Vtransfersourcepis.acctID,
    value: record.Vtransfersourcepis.id,
    label: record.Vtransfersourcepis.friendlyname + " - " + record.Vtransfersourcepis.currcode + " " + record.Vtransfersourcepis.balance
  }));

  useEffect(() => {
    if (options) {
      setSelectedOption(options[0]?.value)
    }
  }, [options])

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleDeposit(event, PIN);
    setShowPinPad(false);
  };

  // Function to handle the deposit action
  const handleDeposit = async (e, pin) => {
    setReceipt(false);
    e.preventDefault();

    if (!inputValue) {  
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please validate your tokens first");
      setHeader("Error");
      return;
    }

    try {
      setIsLoading(true);
      const response = await claimTransfer(
        tokenData.brokerid,
        user['User'].id,
        tokenData.privateWWW,
        tokenData.sourceUserID,
        tokenData.transferID,
        txtoken,
        claimcode,
        tokenData.sourceNodeID,
        tokenData.sourceUserID,
        tokenData.SenderFirstName,
        tokenData.SenderLastName,
        tokenData.recipientname ? tokenData.recipientname : tokenData.SenderFirstName + " " + tokenData.SenderLastName, 
        tokenData.senderpi,
        tokenData.senderpiid,
        tokenData.currID,
        claimAccounts.filter((record) => record.Vtransfersourcepis.id === selectedOption)[0].Vtransfersourcepis.id,
        claimAccounts.filter((record) => record.Vtransfersourcepis.id === selectedOption)[0].Vtransfersourcepis.piid,
        user['User'].countryid,
        tokenData.amountRecipient,
        user['User'].telephoneno,
        user['User'].langID,
        pin,
        agent['User'].id, // agent
        agent['User'].firstName, // agent
        agent['User'].lastName, // agent
        agent['User'].cityname, // agent
        countryList.filter((country) => country.value === agent['User'].countryid)[0]?.label, // agent
        user['User'].address1 + ", " + user['User'].cityname,
        parentuserid,
        isOperator
      ).then((response) => {
          // console.log(response); 
          if (response.callStatus === "1") {
            setShowAlert(true);
            setSeverity("success");
            setMessage("Transfer Completed");
            setHeader("Congratulations!");
            if (pinConfiguration === "once") {
              sessionStorage.setItem("pin", pin);
            }
            setReceiptIDData(response);
            setReceipt(true);
            setInputValue("");
            setFee(0.0);
            setTotal(0.0);
            setSenderName("");
            setClaimCode("");
            setTxToken("");
          }
          else {
            const message = getErrorMessage2(response, isAutoRetry = true);
            setShowAlert(true);
            setSeverity("error");
            setMessage("Transfer Not Completed: " + message);
            setHeader("Error!");
          }
      });
    }
    catch (error) {
      console.log(error);
      setShowAlert(true);
      setSeverity("error");
      setMessage("Transfer Not Completed");
      setHeader("Error!");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }

    getAccounts();
  };

  const handleReceipt = async (event) => {
    event.preventDefault();
    // console.log(receiptIDData)
    try{
      const response = await getReceipts(
        receiptIDData.forCustomer.trngrpid
      ).then((response) => {
        // window.open("https://dev2.4pay.ca/portal/www/php/Workflows/mod_genreceipt.php?type=claimtransfer&id=" + receiptIDData.tngrid, "_blank");
        window.open(
          configVariables.baseURL + 
          configVariables.receiptExtension + 
          "/mod_genreceipt.php?type=claimtransfer&id=" + 
          receiptIDData.tngrid, "_blank"
        );
      })
    }
    catch(error){
      console.log(error);
    }
  };

  const handleValidateToken = async () => {
    if (!txtoken || !claimcode) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please input a valid Transfer Token and Claim Code");
      setHeader("Error!");
      return;
    }

    try{
      const response = await ValidateToken(
        txtoken,
        claimcode,
        user['User'].id,
        agent['User'].id
      );

      if (response?.payload?.callStatus === "0") {
        setShowAlert(true);
        setSeverity("error");
        setMessage(`${response.payload.msg}. Please use a valid Transfer Token and Claim Code`);
        setHeader("Error!");

        setInputValue("");

        return;
      }

      setTokenData(response.ServiceData);
      setInputValue(response.ServiceData.amountRecipient);
      setSenderName(response.ServiceData.recipientname ? response.ServiceData.recipientname : response.ServiceData.SenderFirstName + " " + response.ServiceData.SenderLastName + " [" + response.ServiceData.sendercustomeruserid + "]");
    }
    catch(error){
      console.log(error);
    }
  };

  const handleSubmitButton = () => {
    if (!txtoken || !claimcode || !inputValue) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please input a valid Transfer Token and Claim Code");
      setHeader("Error!");
      return;
    }

    setShowPinPad(true);
  }

  return (
    <Box className="local-transfers-container">
      <Box className="d-flex justify-content-center gap-3 align-items-center">
        <LanguageIcon />
        <Box className="header">Local Transfer Funds</Box>
      </Box>

      {isLoading == true ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <CircularProgress />
        </Box>
      ) : (
        <Box className="local-transfers-form row">
          <Box className="receiver-details col-6">
            <Input
              name="transferToken"
              label="Transfer Token"
              value={txtoken}
              onChange={(e) => setTxToken(e.target.value)}
            />
            <Input
              name="sendAmount"
              label="Claim Code"
              value={claimcode}
              onChange={(e) => setClaimCode(e.target.value)}
            />
            <Box className="validate-token-button">
              <Button onClick={() => {handleValidateToken()}}>Validate Token</Button>
            </Box>
            {/* <Box className="search-result-container">Search Results:</Box> */}
          </Box>
          <Box className="sender-details col-6">
            {" "}
            <Box className="customer-deposit-inputs">
              <form>
                <Select
                  name="myselect"
                  label="Select Claim Option"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  options={options}
                />
                <Input
                  name="sendAmount"
                  label="Enter Transfer Claim Amount"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  disabled={true}
                />
                <Box className="info-box">
                  <Box className="sender-name d-flex justify-content-end gap-2 align-items-center">
                    Recipient Name:
                    <Box className="info-box-info">{senderName}</Box>
                  </Box>
                  <Box className="fee d-flex justify-content-end gap-2 align-items-center">
                    Fee: <Box className="info-box-info">${fee.toFixed(2)}</Box>
                  </Box>
                  <Box className="total d-flex justify-content-end gap-2 align-items-center">
                    Total:{" "}
                    <Box className="info-box-info">${inputValue ? inputValue : total.toFixed(2)}</Box>
                  </Box>
                </Box>
                <Stack spacing={receipt ? 2 : 1} direction="row" className="button-group d-flex justify-content-end mt-3">
                  <BaseButton 
                    buttonText={"Submit"} 
                    onClick={(e) => {{pin ? handleDeposit(e, pin) : pinConfiguration === "never" ? handleDeposit(e, '0000') : handleSubmitButton()}}}
                    />
                    {receipt ? <BaseButton 
                      buttonText={"Receipt"} 
                      buttonStyle="secondary-button-style"
                      onClick={(event) => {handleReceipt(event)}}
                    /> : null}
                </Stack>
              </form>
            </Box>
          </Box>
        </Box>
      )}
      

      <CustomAlert severity={severity} show={showAlert} header={header} message={message} onClick={() => setShowAlert(false)} autoclose={severity === "error" ? false : true} />
      {showPinPad && <PinPad show={showPinPad} handleConfirm={handleConfirm} onClick={() => setShowPinPad(false)} />}
    </Box>
  );
}

export default ClaimLocalTransfers;